import React, { useState } from "react";
import SubscriptionDetails from "../pages/account/SubscriptionDetails.tsx";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation } from "react-router-dom";

const stripePromise = loadStripe("pk_test_PsStkWLos8iklXKKKBcbWltd");

const SubscriptionStripeWrapper = () => {
	return (
		<Elements stripe={stripePromise}>
			<SubscriptionDetails />
		</Elements>
	);
};

export default SubscriptionStripeWrapper;
